module.exports = __webpack_public_path__ + "static/Nanopesos4-97567b2b4f08f31187030314ddf47702.webp";